import { useQuery } from "@apollo/client";
import { createStyles } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { Warehouse_dashboard } from "apollo/queries";
import ManagerDashboard from "components/ManagerDashboard/report";
import ManagertatsGrid from "components/ManagerDashboard/StatGrid";
import { useEffect, useState } from "react";
const dataDashboard = [
  {
    title: "Total Orders",
    icon: "receipt",
    value: "",
    diff: 34,
  },
  {
    title: "Total Sales",
    icon: "discount",
    value: "",
    diff: 18,
  },
  {
    title: "Total Active Orders",
    icon: "user",
    value: "188",
    diff: -6,
  },
];
const useStyles = createStyles((theme) => ({
  userStatusWrapper: {
    flex: 1,
    marginLeft: theme.spacing.md,
  },
}));

const WarhouseManagerDashboard = () => {
  const [timeRange, setTimeRange] = useState("YEARLY");
  const { classes } = useStyles();
  const [selectedBadge, setSelectedBadge] = useState(5);

  const { data, loading, refetch } = useQuery(Warehouse_dashboard, {
    variables: {
      period_type: timeRange,
      limit: selectedBadge,
    },
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message:
          error?.graphQLErrors?.[0]?.message ||
          "Failed to get supplier dashboard",
      });
    },
  });

  useEffect(() => {
    refetch();
  }, []);
  return (
    <div style={{}}>
      <ManagertatsGrid
        loading={loading}
        datas={dataDashboard}
        data={data?.warehouseManagerDashboard}
        timeRange={timeRange}
        onTimeRangeChange={setTimeRange}
      />
      <ManagerDashboard
        selectedBadge={selectedBadge}
        setSelectedBadge={setSelectedBadge}
        data={data?.warehouseManagerDashboard}
      />
    </div>
  );
};

export default WarhouseManagerDashboard;
